import "./style.css";
import { useState, useEffect, useCallback, useMemo } from "react";
import { Col, Form, Row, InputGroup } from "react-bootstrap";
import ButtonCom from "../../components/button/button";
import { Link, useNavigate } from "react-router-dom";
import { HiArrowLongRight } from "react-icons/hi2";
import { TiDeleteOutline } from "react-icons/ti";
import { CiMenuKebab } from "react-icons/ci";
import { GrDocumentExcel } from "react-icons/gr";
import { CiLock } from "react-icons/ci";
import { HiOutlineDocumentCurrencyRupee } from "react-icons/hi2";
import { LuNotebook } from "react-icons/lu";
import { CiWallet } from "react-icons/ci";
import { AgGridReact } from "ag-grid-react";
import DatePicker from "react-datepicker";
import { LuCalendarDays } from "react-icons/lu";
import { RxCross2 } from "react-icons/rx";
import { LiaRupeeSignSolid } from "react-icons/lia";

import { CiUser } from "react-icons/ci";
import Widgets from "../../components/Widgets";
import WidgetsIcon from "../../components/Widgets/icon";

import {
  downloadCSV,
  getInitialColor,
  getInitials,
  formattedAttDashboard,
} from "../../services/commonServices.js";

import {
  fetchBranchData,
  initBranchState,
} from "../../redux/slices/branchSlice";
import {
  fetchDepartmentData,
  initDepartState,
} from "../../redux/slices/departmentSlice";
import { fetchData, initShiftState } from "../../redux/slices/shiftsSlice";

import { useDispatch, useSelector } from "react-redux";
import { Height } from "@mui/icons-material";

import {
  getRunPayrollEmployeePath,
  employeeAttendanceDashboardPath,
} from "../../services/config.js";
import {
  commonSaveData,
  commonSaveDataOne,
  initCommonState,
} from "../../redux/slices/commonSlice.js";

const AttendanceDashboard = () => {
  const dispatch = useDispatch();

  const user = JSON.parse(localStorage.getItem("user_data")) || {};

  const branchState = useSelector((state) => state.branch);
  const departState = useSelector((state) => state.department);
  const shiftState = useSelector((state) => state.shift);
  const commonStore = useSelector((state) => state.common);

  const [attendanceDbList, setAttendanceDbList] = useState([]);
  const [attendanceDbListOne, setAttendanceDbListOne] = useState([]);
  const [branch, setBranch] = useState([]);
  const [depart, setDepart] = useState([]);
  const [shift, setShift] = useState([]);
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);

  const [addCtc, setAddCtc] = useState({});
  const [salaryCtc, setSalaryCtc] = useState({});

  const [isActive, setIsActive] = useState(false);
  const [isAddCtcActive, setIsAddCtcActive] = useState(false);
  const [staffName, setStaffName] = useState(null);
  const [staffId, setStaffId] = useState(null);

  const [state, setState] = useState({
    selectedDate: "",
    branch: "",
    shiftId: "",
  });

  const [startLeavingDate, setStartLeavingDate] = useState(null);
  const [endLeavingDate, setEndLeavingDate] = useState(null);

  const [maxMonth, setMaxMonth] = useState("");
  const date = new Date();
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, "0");
  useEffect(() => {
    setMaxMonth(`${year}-${month}`);
    setState((prev) => ({
      ...prev,
      selectedDate: `${year}-${month}`,
    }));
  }, []);

  const getData = useCallback(() => {
    dispatch(fetchBranchData(user.user_id));
    dispatch(fetchDepartmentData(user.user_id));
    dispatch(fetchData(user.user_id));
  }, []);

  useEffect(() => {
    getData();
  }, []);

  const getRunPayroll = (selectedDate, branch, shiftId) => {
    if (selectedDate != "") {
      const data = {
        path: employeeAttendanceDashboardPath,
        data: {
          userId: user.user_id,
          selectedDate: `${selectedDate}-01`,
          branchId: branch,
          shiftId: shiftId,
        },
      };
      dispatch(commonSaveDataOne(data));
    }
  };

  const handelChange = ({ target: { name, value } }) => {
    setState((prev) => ({
      ...prev,
      [name]: value,
    }));
    if (name == "selectedDate") {
      getRunPayroll(value, state.branch, state.shiftId);
      return;
    }
    if (name == "branch") {
      getRunPayroll(state.selectedDate, value, state.shiftId);
      return;
    }
    if (name == "shiftId") {
      getRunPayroll(state.selectedDate, state.branch, value);
      return;
    }
  };

  useEffect(() => {
    if (state.selectedDate) {
      getRunPayroll(state.selectedDate, state.branch, state.shiftId);
    }
  }, [state.selectedDate, state.branch, state.shiftId]);

  const [isCtcSaved, setIsCtcSaved] = useState(false);

  useEffect(() => {
    if (branchState.brnGetSuccess) {
      setBranch(branchState.brnGetData);
      dispatch(initBranchState());
    }

    if (departState.depGetSuccess) {
      setDepart(departState.depGetData);
      dispatch(initDepartState());
    }

    if (shiftState.shiftGetSuccess) {
      setShift(shiftState.shiftGetData);
      dispatch(initShiftState());
    }

    if (commonStore.commonSuccessOne) {
      setAttendanceDbList(commonStore.commonDataOne.staffAttendanceData);
      setAttendanceDbListOne(commonStore.commonDataOne.staffAttendanceData);
      dispatch(initCommonState());
    }
  }, [branchState, departState, shiftState, commonStore]);

  const handleClickFromD1 = (id) => {
    document.getElementById(id).click();
  };

  const paginationPageSize = 10;
  const paginationPageSizeSelector = [10, 20, 50, 100];

  const columns = useMemo(
    () => [
      {
        headerName: "Staff Name",
        cellRenderer: (rowData) => {
          return (
            <>
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: "10px",
                  cursor: "pointer",
                  height: "auto", // Adjusted from fixed height
                  overflow: "unset",
                }}
              >
                <div
                  style={{
                    width: "30px",
                    height: "30px",
                    border: "1px solid lightgray",
                    borderRadius: "50%",
                    overflow: "hidden",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    backgroundColor: getInitialColor(rowData.data.staffName), // 🎯 Apply color
                    color: "white", // Text contrast
                    fontWeight: "bold",
                    fontSize: "12px",
                  }}
                >
                  {getInitials(rowData.data.staffName)}
                  {/* <img
                    src={Avatar}
                    style={{ width: "40px", height: "40px", borderRadius: "50%" }}
                  /> */}
                </div>
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "flex-start",
                    gap: "10px",
                  }}
                >
                  <h4>{rowData.data.staffName}</h4>
                  {/* <p
                    style={{
                      fontSize: "12px",
                      color: "gray",
                    }}
                  >
                    ({rowData.data.employeeId})
                  </p> */}
                </div>
              </div>
            </>
          );
        },
        // flex: 1,
        pinned: "left",
        height: "60px",
        width: "200px",
      },
      {
        headerName: "Phone Number",
        width: "130px",
        cellRenderer: (rowData) => {
          return <span>{rowData.data.mobileNumber}</span>;
        },
      },
      {
        headerName: "Employee ID",
        width: "120px",
        cellRenderer: (rowData) => {
          return <span>{rowData.data.employeeId}</span>;
        },
      },
      {
        headerName: "Job Title",
        field: "jobTitle",
        width: "130px",
      },
      {
        headerName: "Present",
        field: "attendanceSummary.Present",
        wrapHeaderText: true,
        autoHeaderHeight: true,
        width: "80px",
      },
      {
        headerName: "Absent",
        field: "attendanceSummary.Absent",
        wrapHeaderText: true,
        autoHeaderHeight: true,
        width: "80px",
      },
      {
        headerName: "Half Day",
        valueGetter: (params) => params.data.attendanceSummary?.["Half Day"],
        wrapHeaderText: true,
        autoHeaderHeight: true,
        width: "80px",
      },
      {
        headerName: "Week Off",
        field: "attendanceSummary.WeekOff",
        wrapHeaderText: true,
        autoHeaderHeight: true,
        width: "80px",
      },
      {
        headerName: "Holiday",
        field: "attendanceSummary.Holiday",
        wrapHeaderText: true,
        autoHeaderHeight: true,
        width: "80px",
      },
      {
        headerName: "Paid Leave",
        valueGetter: (params) => params.data.attendanceSummary?.["Paid Leave"],
        wrapHeaderText: true,
        autoHeaderHeight: true,
        width: "80px",
      },
      {
        headerName: "Unpaid Leave",
        valueGetter: (params) =>
          params.data.attendanceSummary?.["Un Paid Leave"],
        wrapHeaderText: true,
        autoHeaderHeight: true,
        width: "80px",
      },
      {
        headerName: "Overtime On Working Day",
        valueGetter: (params) =>
          params.data.attendanceSummary?.["Un Paid Leave"],
        wrapHeaderText: true,
        autoHeaderHeight: true,
        width: "80px",
      },
      {
        headerName: "Overtime On Week Off",
        valueGetter: (params) =>
          params.data.attendanceSummary?.["Un Paid Leave"],
        wrapHeaderText: true,
        autoHeaderHeight: true,
        width: "80px",
      },
      {
        headerName: "Overtime On Holiday",
        valueGetter: (params) =>
          params.data.attendanceSummary?.["Un Paid Leave"],
        wrapHeaderText: true,
        autoHeaderHeight: true,
        width: "80px",
      },
      {
        headerName: "Late Coming",
        valueGetter: (params) =>
          params.data.attendanceSummary?.["Late CheckIn"],
        wrapHeaderText: true,
        autoHeaderHeight: true,
        width: "80px",
      },
      {
        headerName: "Early Leaving",
        valueGetter: (params) =>
          params.data.attendanceSummary?.["Early CheckOut"],
        wrapHeaderText: true,
        autoHeaderHeight: true,
        width: "80px",
      },
    ],
    []
  );

  const filterRecord = ({ target: { checked } }) => {
    if (checked) {
      const array = attendanceDbListOne.filter(
        (item) => item.status == "Active"
      );
      setAttendanceDbList(array);
    } else {
      setAttendanceDbList(attendanceDbListOne);
    }
  };

  const [searchQuery, setSearchQuery] = useState("");
  const searchEmployees = ({ target: { value } }) => {
    setSearchQuery(value);
    const filteredEmployees = attendanceDbListOne.filter((v) =>
      v.staffName.toLowerCase().includes(value.toLowerCase())
    );
    setAttendanceDbList(filteredEmployees);
  };

  const resetFilter = () => {
    setState((prev) => ({
      ...prev,
      selectedDate: `${year}-${month}`,
      branch: "",
      shiftId: "",
    }));
    getRunPayroll(`${state.selectedDate}-01`, state.branch, state.shiftId);
    setSearchQuery("");
    // document.querySelector("#filterCheckbox").checked = false;
  };

  const toggleAddCtc = () => {
    setIsActive(false);
    setSalaryCtc({});
    localStorage.removeItem("ctc-added");
    setAddCtc({});
  };

  const toggleCtc = () => {
    setIsAddCtcActive(false);
  };

  const handleViewCtc = (data) => {
    setStaffId(data.staffId);
    setStaffName(data.fullName);
    setAddCtc(data);
    setIsActive(true);
  };

  const handleAddCtc = (data) => {
    setIsActive(false);
    setIsAddCtcActive(true);
  };

  const handleSaveSalary = () => {
    const salaryC = JSON.parse(localStorage.getItem("ctc-added")) || {};
    setSalaryCtc(salaryC);
    setIsAddCtcActive(false);
    setIsActive(true);
  };

  const handleDownloadCSV = () => {
    downloadCSV(
      formattedAttDashboard(attendanceDbList),
      `Attendance_Dashboard_${state.selectedDate}`
    );
  };

  // HTML ELEMENT RENDERING ---------------------------------------------------
  return (
    <>
      <div
        style={{
          position: "fixed",
          marginTop: "-30px",
          height: "100%",
          width: "100%",
          backgroundColor: "transparent",
          padding: "20px",
          zIndex: "1",
        }}
      >
        <Row>
          <Col sm="12">
            <Widgets
              icon={
                <div className="d-flex justify-content-start gap-3">
                  <Form.Group>
                    <Form.Control
                      name="searchQuery"
                      value={searchQuery}
                      onChange={searchEmployees}
                      placeholder="Search"
                      style={{ width: "450px" }}
                      className="universal-input border-gray"
                    />
                  </Form.Group>

                  <Form.Group>
                    <Form.Control
                      type="month"
                      name="selectedDate"
                      value={state.selectedDate}
                      max={maxMonth}
                      onChange={handelChange}
                      className="universal-input"
                    />
                  </Form.Group>

                  <Form.Group>
                    <Form.Select
                      name="branch"
                      value={state.branch}
                      onChange={handelChange}
                      className="universal-input"
                    >
                      <option value="">All Branches</option>
                      {branch.map((row, idx) => {
                        return (
                          <option value={row.branchId} key={idx}>
                            {row.branch_name}
                          </option>
                        );
                      })}
                    </Form.Select>
                  </Form.Group>

                  <Form.Group>
                    <Form.Select
                      name="shiftId"
                      value={state.shiftId}
                      onChange={handelChange}
                      className="universal-input"
                    >
                      <option value="">All Shift</option>
                      {shift.map((row, idx) => {
                        return (
                          <option value={row.shiftId} key={idx}>
                            {row.shiftName}
                          </option>
                        );
                      })}
                    </Form.Select>
                  </Form.Group>
                </div>
              }
              button={
                <Form.Group>
                  <ButtonCom
                    type={"button"}
                    class_name={"p_btn universal-input border-gray"}
                    text="Download"
                    url_or_onclick={handleDownloadCSV}
                    icon={null}
                    width={""}
                  />
                </Form.Group>
              }
              body={
                <div
                  style={{
                    position: "relative",
                    height: "100%",
                    overflowX: "overflow",
                  }}
                >
                  <div
                    className="ag-theme-quartz custom-grid"
                    style={{
                      position: "relative",
                      height: "420px",
                      width: "100%",
                      padding: "10px 20px",
                      zIndex: "0",
                    }}
                  >
                    <AgGridReact
                      rowData={
                        Array.isArray(attendanceDbList) ? attendanceDbList : []
                      }
                      columnDefs={columns}
                      omLayout="autoHeight"
                      pagination={true}
                      paginationPageSize={paginationPageSize}
                      paginationPageSizeSelector={paginationPageSizeSelector}
                    />
                  </div>
                </div>
              }
            />
          </Col>
        </Row>
      </div>

      <div className={isActive ? "date-hamberger active" : "date-hamberger"}>
        <div
          className="date-hamberger-header"
          style={{
            display: "flex",
            alignItem: "center",
            justifyContent: "space-between",
            fontSize: "14px",
          }}
        >
          <div>
            <RxCross2
              className="icon"
              style={{ fontSize: "15px", marginTop: "2px" }}
              onClick={toggleAddCtc}
            />

            <span style={{ marginLeft: "10px" }}>{staffName}</span>
          </div>
          <span>{state.selectedDate}</span>
        </div>
        <div className="date-hamberger-body"></div>
      </div>
    </>
  );
};

export default AttendanceDashboard;